import { render, staticRenderFns } from "./provider-details.vue?vue&type=template&id=0a4ec66e&scoped=true"
import script from "./provider-details.vue?vue&type=script&lang=js"
export * from "./provider-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4ec66e",
  null
  
)

export default component.exports